var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[(_vm.$route.meta.isFull)?_c('router-view'):[_c('nh-header'),_c('nh-main')]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }